import React from 'react';
import { Box, InputAdornment, TextField, Typography } from '@mui/material';

const HEX_RE = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

// Solid-hex color picker: native <input type="color"> swatch + a synced hex
// text field. No extra dependencies.
const ColorField = ({ label, value, onChange }) => {
  const safe = HEX_RE.test(value || '') ? value : '#000000';
  return (
    <Box>
      <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
        {label}
      </Typography>
      <TextField
        size="small"
        fullWidth
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        error={!!value && !HEX_RE.test(value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Box
                component="input"
                type="color"
                value={safe}
                onChange={(e) => onChange(e.target.value.toUpperCase())}
                aria-label={`${label} color picker`}
                sx={{
                  width: 28,
                  height: 28,
                  p: 0,
                  border: 'none',
                  bgcolor: 'transparent',
                  cursor: 'pointer',
                  colorScheme: (theme) => theme.palette.mode,
                }}
              />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default ColorField;
